import { Icon } from "../../../../../../components";

type Props = {
  id: string;
};

const DragAndDropIcon = ({ id }: Props) => (
  <Icon style={{ cursor: "move" }} id={id} name="drag-and-drop" />
);

export default DragAndDropIcon;
